import React, { useContext, useEffect } from 'react';
import './Info.scss';
import { Context } from '../@context/Context';


const Info = (props) => {
    const {
        state: { error },
        actions: { setError }
    } = useContext(Context);

    useEffect(() => {
        setTimeout(() => setError({ text: '', show: false, type: '', body: null }), 10000)
    }, [error.show])

    const className = error.show ? 'info__container info__container-err' : null;

    return (
        <div className="container container_center">
            <div className={className}>
                <p className="info__text">
                    {
                        error.text
                    }
                </p>
            </div>
        </div>
    )
}


export default Info;